<div class="menu" *ngIf="_active">
  <ng-container *ngFor="let blok of links">
    <ndc-dynamic
      *ngIf="components"
      [ndcDynamicComponent]="components[blok.component]"
      [ndcDynamicInputs]="blok"
    >
    </ndc-dynamic>
  </ng-container>
</div>
